import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('notice-click')),
    style: {
      "cursor": "pointer"
    }
  }, [_createElementVNode("div", _hoisted_1, _toDisplayString($props.notice.noticeName), 1), _createElementVNode("div", {
    class: "content",
    innerHTML: $props.notice.noticeContent
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString($props.notice.startTime), 1)]);
}